import React, { useEffect, useState } from 'react';
import CollapsibleMenuComponent from './Collapsible_menu_component';

const CategoryListComponent = ({ targetLabel }) => {

  const [width, setWidth] = useState(window.innerWidth);
  const [menuData, setMenuData] = useState([
    {
      label: 'Audio',
      initiallyOpen: false,
      children: [
        {
          label: 'Headphones',
          initiallyOpen: false,
          children: [
            { label: 'AirPods' },
            { label: 'Bluetooth Headphones' },
            { label: 'Earbuds' },
            { label: 'Earphones' },
            { label: 'Wireless Headphones' }
          ]
        },
        {
          label: 'Speakers',
          initiallyOpen: false,
          children: [
            { label: 'Bluetooth Speakers' },
            { label: 'Home Theater System' },
            { label: 'Music Player' },
            {
              label: 'Party Box',
              initiallyOpen: false,
              children: [
                { label: 'Microphone' },
              ]
            },
            { label: 'Soundbars' },
            { label: 'Standing Speaker' }
          ]
        }
      ]
    },
    {
      label: 'Cameras & Accessories',
      initiallyOpen: false,
      children: [
        { label: 'Batteries' },
        {
          label: 'Camera',
          initiallyOpen: false,
          children: [
            { label: '360 Degree Cameras' },
            { label: 'Action Cameras' },
            { label: 'Camcorders' },
            { label: 'DSLR Cameras' },
            { label: 'Mirrorless Cameras' },
          ]
        },
        { label: 'Camera Lenses' },
        { label: 'Flash Accessories' },
        { label: 'Projectors' },
      ]
    },
    {
      label: 'Computer & Laptop',
      initiallyOpen: false,
      children: [
        { label: 'Budget Laptops' },
        {
          label: 'Desktop',
          initiallyOpen: false,
          children: [
            { label: 'All in One PCs' },
          ]
        },
        { label: 'Gaming Laptops' },
        { label: 'Laptops' },
        { label: 'Monitors' },
      ]
    },
    {
      label: 'Computer & Laptop Accessories',
      initiallyOpen: false,
      children: [
        { label: 'Backpack' },
        {
          label: 'Data Storage',
          initiallyOpen: false,
          children: [
            { label: 'Hard Drives' },
            { label: 'Memory Cards' },
            { label: 'Pen Drives' },
            { label: 'Solid State Drives' },
          ]
        },
        { label: 'Keyboard & Mouse Combo' },
        { label: 'Keyboards' },
        { label: 'Laptop Bags' },
        { label: 'Mouse' },
        {
          label: 'PC Accessories',
          initiallyOpen: false,
          children: [
            { label: 'Batteries' },
            { label: 'Cables' },
            { label: 'Headphones with Mic' },
            { label: 'Mic' },
            { label: 'PC Speakers' },
          ]
        },
        {
          label: 'Printers',
          initiallyOpen: false,
          children: [
            { label: 'Inkjet Printers' },
            { label: 'Laser Printers' },
            { label: 'Thermal Printers' },
            { label: 'Ink Tank Printers' },
            { label: 'Ink & Toner' },
          ]
        },
      ]
    },
    {
      label: 'Cookware',
      initiallyOpen: false,
      children: [
        { label: 'Biryani Pot' },
        { label: 'Cookware Sets' },
        { label: 'Electric Cooker' },
        { label: 'Frying Pans' },
        { label: 'Kadai' },
        {
          label: 'Pressure Cookers',
          initiallyOpen: false,
          children: [
            { label: 'Inner Lid' },
            { label: 'Outer Lid' },
          ]
        },
        { label: 'Rice Cooker' },
        { label: 'Tadka Pans' },
        { label: 'Tawas' },
      ]
    },
    {
      label: 'Digital Game & Accessories',
      initiallyOpen: false,
      children: [
        { label: 'Playstation' },
      ]
    },
    {
      label: 'Electronic Accessories',
      initiallyOpen: false,
      children: [
        { label: 'Power Bank' },
        {
          label: 'Smart Watch',
          initiallyOpen: false,
          children: [
            { label: 'Apple Watch' },
            { label: 'Fitness Band' },
          ]
        },
      ]
    },
    {
      label: 'Heating, Cooling & Air Quality',
      initiallyOpen: false,
      children: [
        {
          label: 'Air Coolers',
          initiallyOpen: false,
          children: [
            { label: '24 Ltrs' },
            { label: '32 Ltrs' },
            { label: '54 Ltrs' },
            { label: '60 Ltrs' },
          ]
        },
        { label: 'Air Purifiers' },
        { label: 'Dehumidifiers' },
        {
          label: 'Fans',
          initiallyOpen: false,
          children: [
            { label: 'Ceiling Fans' },
            { label: 'Exhaust Fans' },
            { label: 'Pedestal Fans' },
            { label: 'Table Fans' },
            { label: 'Tower Fans' },
          ]
        },
        { label: 'Humidifiers' },
        { label: 'Immersion Rod' },
        { label: 'Room Heaters' },
        {
          label: 'Water Heaters and Geysers',
          initiallyOpen: false,
          children: [
            { label: '10 Ltrs' },
            { label: '15 Ltrs' },
            { label: '25 Ltrs' },
            { label: '3 Ltrs' },
            { label: '6 Ltrs' },
          ]
        },
      ]
    },
    {
      label: 'Home Appliances',
      initiallyOpen: false,
      children: [
        {
          label: 'Air Conditioners',
          initiallyOpen: false,
          children: [
            {
              label: 'Split AC',
              initiallyOpen: false,
              children: [
                {
                  label: 'Inverter AC',
                  initiallyOpen: false,
                  children: [
                    {
                      label: '0.8 Ton',
                      initiallyOpen: false,
                      children: [
                        { label: '3 stars' },

                      ]
                    },
                    {
                      label: '1 to 1.3 Tons',
                      initiallyOpen: false,
                      children: [
                        { label: '3 stars' },
                        { label: '4 stars' },
                        { label: '5 stars' },
                      ]
                    },
                    {
                      label: '1.4 to 1.5 Tons',
                      initiallyOpen: false,
                      children: [
                        { label: '3 stars' },
                        { label: '5 stars' },
                      ]
                    },
                    {
                      label: '1.6 to 1.9 Tons',
                      initiallyOpen: false,
                      children: [
                        { label: '3 stars' },
                      ]
                    },
                    {
                      label: '2 Tons & above',
                      initiallyOpen: false,
                      children: [
                        { label: '3 stars' },
                        { label: '4 stars' },
                        { label: '5 stars' },
                      ]
                    },
                  ]
                },
                {
                  label: 'Non Inverter AC',
                  initiallyOpen: false,
                  children: [
                    {
                      label: '1 to 1.3 Tons',
                      initiallyOpen: false,
                      children: [
                        { label: '3 stars' },
                        { label: '4 stars' },
                        { label: '5 stars' },
                      ]
                    },
                    {
                      label: '1.4 to 1.5 Ton',
                      initiallyOpen: false,
                      children: [
                        { label: '2 stars' },
                        { label: '3 stars' },
                        { label: '4 stars' },
                        { label: '5 stars' },
                      ]
                    },
                    { label: '2 Ton & above' },
                  ]
                },
              ]
            },
            {
              label: 'Window AC',
              initiallyOpen: false,
              children: [
                {
                  label: 'Inverter AC',
                  initiallyOpen: false,
                  children: [
                    {
                      label: '1 to 1.3 Tons',
                      initiallyOpen: false,
                      children: [
                        { label: '3 stars' },
                        { label: '4 stars' },
                        { label: '5 stars' },
                      ]
                    },
                    {
                      label: '1.4 to 1.5 Ton',
                      initiallyOpen: false,
                      children: [
                        { label: '3 stars' },
                        { label: '4 stars' },
                        { label: '5 stars' },
                      ]
                    },
                    {
                      label: '1.7 to 2 Ton',
                      initiallyOpen: false,
                      children: [
                        { label: '3 stars' },
                      ]
                    }
                  ]
                },
              ]
            },
          ]
        },
        { label: 'Dishwashers' },
        { label: 'Inverters' },
        {
          label: 'Refrigerators',
          initiallyOpen: false,
          children: [
            {
              label: 'Bottom Mount',
              initiallyOpen: false,
              children: [
                { label: '201-230 Ltrs' },
                { label: '231-300 Ltrs' },
                { label: '301-400 Ltrs' },
                { label: '401 Ltrs & above' },
              ]
            },
            {
              label: 'Deep Fridge',
              initiallyOpen: false,
              children: [
                { label: '100-200 Ltrs' },
                { label: '201-300 Ltrs' },
              ]
            },
            {
              label: 'Double Door',
              initiallyOpen: false,
              children: [
                { label: 'upto 120 Ltrs' },
                { label: '121-200 Ltrs' },
                { label: '201-230 Ltrs' },
                { label: '231-300 Ltrs' },
                { label: '301-400 Ltrs' },
                { label: '401 Ltrs & above' },
              ]
            },
            {
              label: 'Mini Refrigerator',
              initiallyOpen: false,
              children: [
                { label: '95 Ltrs' },
              ]
            },
            {
              label: 'Single Door',
              initiallyOpen: false,
              children: [
                { label: 'upto 120 Ltrs' },
                { label: '121-200 Ltrs' },
                { label: '201-230 Ltrs' },
                { label: '231-300 Ltrs' },
                { label: '301-400 Ltrs' },
                { label: '401 Ltrs & above' },
              ]
            },
            {
              label: 'Triple Door',
              initiallyOpen: false,
              children: [
                { label: 'upto 120 Ltrs' },
                { label: '121-200 Ltrs' },
                { label: '201-230 Ltrs' },
                { label: '231-300 Ltrs' },
                { label: '301-400 Ltrs' },
                { label: '401 Ltrs & above' },
              ]
            },
          ]
        },
        {
          label: 'Washing Machines',
          initiallyOpen: false,
          children: [
            {
              label: 'Front Load',
              initiallyOpen: false,
              children: [
                { label: '10.0 KGs' },
                { label: '6.0 KGs' },
                { label: '6.5 KGs' },
                { label: '7.0 KGs' },
                { label: '7.5 KGs' },
                { label: '8.0 KGs' },
                { label: '8.5 KGs' },
                { label: '9.0 KGs' },
                { label: '9.5 KGs' },
              ]
            },
            {
              label: 'Semi Automatic',
              initiallyOpen: false,
              children: [
                { label: '10.0 KGs' },
                { label: '6.0 KGs' },
                { label: '6.5 KGs' },
                { label: '7.0 KGs' },
                { label: '7.2 KGs' },
                { label: '7.5 KGs' },
                { label: '8.0 KGs' },
                { label: '8.5 KGs' },
                { label: '9.0 KGs' },
                { label: '9.5 KGs' },
              ]
            },
            {
              label: 'Top Load',
              initiallyOpen: false,
              children: [
                { label: '10.0 KGs' },
                { label: '6.0 KGs' },
                { label: '6.5 KGs' },
                { label: '7.0 KGs' },
                { label: '7.5 KGs' },
                { label: '8.0 KGs' },
                { label: '8.5 KGs' },
                { label: '9.0 KGs' },
                { label: '9.5 KGs' },
              ]
            },
            { label: 'Washer Dryer' },
          ]
        },
        {
          label: 'Water Purifiers',
          initiallyOpen: false,
          children: [
            { label: 'Water Dispenser' },
          ]
        },
      ]
    },
    { label: 'Hot Deals' },
    {
      label: 'Kitchen Appliances',
      initiallyOpen: false,
      children: [
        { label: 'Air Fryer' },
        { label: 'Coffee Machine' },
        { label: 'Deep Fryer' },
        { label: 'Food Processors' },
        { label: 'Gas Cooktop' },
        { label: 'Hand Blenders' },
        { label: 'Induction Cooktop' },
        { label: 'Juicer Mixer Grinder' },
        { label: 'Kitchen Chimney' },
        {
          label: 'Microwave Oven',
          initiallyOpen: false,
          children: [
            {
              label: 'Convection',
              initiallyOpen: false,
              children: [
                { label: 'upto 20 Ltrs' },
                { label: '21 - 25 Ltrs' },
                { label: '26 - 30 Ltrs' },
                { label: '31 Ltrs & More' },
              ]
            },
            {
              label: 'Grill',
              initiallyOpen: false,
              children: [
                { label: 'upto 20 Ltrs' },
                { label: '21 - 25 Ltrs' },
                { label: '26 - 30 Ltrs' },
                { label: '31 Ltrs & More' },
              ]
            },
            {
              label: 'Solo',
              initiallyOpen: false,
              children: [
                { label: 'upto 20 Ltrs' },
                { label: '21 - 25 Ltrs' },
                { label: '26 - 30 Ltrs' },
                { label: '31 Ltrs & More' },
              ]
            },
          ]
        },
        {
          label: 'Mixer Grinder',
          initiallyOpen: false,
          children: [
            { label: '1000 Watt' },
            { label: '500 Watt' },
            { label: '550 Watt' },
            { label: '600 Watt' },
            { label: '750 Watt' },
            { label: '800 Watt' },
          ]
        },
        { label: 'Oven Toaster Grills' },
        { label: 'Rice & Pasta Cookers' },
        { label: 'Roti Maker' },
        { label: 'Sandwich Makers' },
      ]
    },
    {
      label: 'Kitchen Storage & Containers',
      initiallyOpen: false,
      children: [
        { label: 'Jars & Containers' },
        { label: 'Lunch Boxes' },
        { label: 'Water Bottles & Flasks' },
      ]
    },
    {
      label: 'Kitchen Tools',
      initiallyOpen: false,
      children: [
        { label: 'Baking Tools' },
        { label: 'Electric Chopper' },
        { label: 'Graters & Slicers' },
        { label: 'Hand Mixers' },
        { label: 'Knives' },
        { label: 'Mini Chopper' },
      ]
    },
    {
      label: 'Lifestyle Products',
      initiallyOpen: false,
      children: [
        { label: 'Hair Clipper' },
        { label: 'Hair Curler' },
        { label: 'Hair Dryer' },
        { label: 'Hair Straightener' },
        { label: 'Hair Removal' },
        { label: 'Mini Styler' },
        { label: 'Shaver' },
        { label: 'Trimmer' },
      ]
    },
    {
      label: 'Mobile & Tab',
      initiallyOpen: false,
      children: [
        {
          label: 'iPhone',
          initiallyOpen: false,
          children: [
            { label: 'iPhone 13' },
            { label: 'iPhone 14' },
            { label: 'iPhone 15' },
            { label: 'iPhone 16' },
            { label: 'iPhone 16e' },
          ]
        },
        { label: 'Keypad Mobile' },
        { label: 'Mobile New Arrival' },
        { label: 'Tablet' },
        {
          label: 'Smart Phone',
          initiallyOpen: false,
          children: [
            {
              label: 'Google Mobile',
              initiallyOpen: false,
              children: [
                { label: 'Pixel 8a' },
                { label: 'Pixel 9' },
              ]
            },
            {
              label: 'Nothing Mobile',
              initiallyOpen: false,
              children: [
                { label: 'CNF Phone 1' },
                { label: 'Phone (2a)' },
              ]
            },
            {
              label: 'OPPO Mobile',
              initiallyOpen: false,
              children: [
                { label: 'OPPO Reno 11' },
                { label: 'OPPO Reno 13' },
                { label: 'OPPO A59 5G' },
                { label: 'OPPO F25 PRO' },
              ]
            },
            {
              label: 'Realmme Mobile',
              initiallyOpen: false,
              children: [
                { label: 'Realmme 12 Pro' },
                { label: 'Realmme 14' },
                { label: 'Realmme C65' },
              ]
            },
            {
              label: 'Redmi Mobile',
              initiallyOpen: false,
              children: [
                { label: 'Redmi 13C 5G' },
                { label: 'Redmi A3' },
              ]
            },
            {
              label: 'Samsung Mobile',
              initiallyOpen: false,
              children: [
                { label: 'Samsung A Series' },
                { label: 'Samsung A35' },
                { label: 'Samsung A55' },
                { label: 'Samsung F55' },
                { label: 'Samsung S23' },
                { label: 'Samsung S23 FE' },
                { label: 'Samsung S24' },
                { label: 'Samsung S25' },
              ]
            }
          ]
        }
      ]
    },
    {
      label: 'Mobile Accessories',
      initiallyOpen: false,
      children: [
        { label: 'Data Cables' },
        { label: 'Power Adapter' },
        { label: 'Screen guards' },
        { label: 'Mobile Chargers' },
      ]
    },
    {
      label: 'Small Appliances',
      initiallyOpen: false,
      children: [
        { label: 'Electric Kettle' },
        { label: 'Garments Steamer' },
        { label: 'Irons' },
        { label: 'Sewing Machine & Accessories' },
        { label: 'Toasters' },
        { label: 'Vacuum Cleaners' },
      ]
    }
  ]);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    updateMenuState(menuData, targetLabel);
  }, [targetLabel]);

  function updateMenuState(menu, target) {
    function dfs(node, parents) {
        if (node.label === target) {
            node.initiallyOpen = true;
            parents.forEach(parent => parent.initiallyOpen = true);
            return true;
        }
        
        if (node.children) {
            for (let child of node.children) {
                if (dfs(child, [...parents, node])) {
                    node.initiallyOpen = true; // Ensure each parent in the hierarchy is opened
                    return true;
                }
            }
        }
        
        return false;
    }
    
    for (let item of menu) {
        if (dfs(item, [])) {
            item.initiallyOpen = true; // Ensure the top-level parent opens
        }
    }
}


  return (
    <div className="app">
      <CollapsibleMenuComponent
        menuData={menuData}
        width={width > 768 ? '100%' : '100%'}
        style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
      />
    </div>
  );
};

export default CategoryListComponent;